'use strict';

let _ = require('lodash');
let Attribute = require('./../index');

/**
 * Abstract class for attributes that represent collections (i.e. 'listOfRanges', 'listOfValues')
 */
class CollectionAttribute extends Attribute {
    constructor(config) {
        super(config);
    }

    /**
     * @param  {string} value to search for.
     * @return {bool} true if and only if the value is within this attribute
     */
    contains(value) {
        throw new Error(`contains(...) is not implemented on this class and cannot consume ${value}`);
    }

    get values() {
        throw new Error('get values() is not implemented on this class');
    }

    get validOptions() {
        throw new Error('get validOptions() is not implemented on this class');
    }
}

module.exports = CollectionAttribute;
